import React from "react";
import { defineMessages, useIntl } from "react-intl";
import { isStringNullOrEmpty } from "../../utils/string.js";
import "moment-timezone";
const localized = defineMessages({
  NA: {
    id: "EmptyLabel_NA",
    defaultMessage: "N/A"
  }
});
const dashCharacter = "—";
const notAvailableCharacter = "N/A";
function useDefaultSymbol(value = "none") {
  const { formatMessage } = useIntl();
  const defaultSymbolMap = {
    dash: dashCharacter,
    invisible: "‍",
    none: "",
    "N/A": formatMessage(localized.NA)
  };
  return defaultSymbolMap[value];
}
function EmptyLabel(props) {
  const symbol = useDefaultSymbol(props?.defaultSymbol);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, symbol);
}
const withEmptyCheck = (WrappedComponent) => (props) => {
  const { value } = props;
  const isEmpty = isEmptyCellValue(value);
  return isEmpty ? /* @__PURE__ */ React.createElement(EmptyLabel, { defaultSymbol: "dash" }) : /* @__PURE__ */ React.createElement(WrappedComponent, { ...props });
};
function isEmptyCellValue(value) {
  return value === null || value === void 0 || Array.isArray(value) && value?.length === 0 || typeof value === "string" && isStringNullOrEmpty(value) || typeof value === "number" && isNaN(value);
}
const TextWithEmptyCheck = withEmptyCheck(({ value }) => /* @__PURE__ */ React.createElement(React.Fragment, null, value));
export {
  EmptyLabel,
  TextWithEmptyCheck,
  dashCharacter,
  isEmptyCellValue,
  notAvailableCharacter,
  useDefaultSymbol,
  withEmptyCheck
};
//# sourceMappingURL=EmptyLabel.js.map
